// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1HOo2","clinicsSelect":"TableHeading_clinicsSelect__1QjEi"};